class MobileHeaderLayoutController {
  constructor() {
    this.header = document.querySelector("header");
    this.heading = this.header.querySelector(".header__heading");
    this.headerIcons = this.header.querySelector(".header__icons");
    this.drawer = this.header.querySelector("#header-drawer-metaobject");
    this.drawerDetails = this.header.querySelector(
      "#Details-menu-drawer-container"
    );
    this.summary = this.header.querySelector("summary.header__icon--summary");

    if (window.innerWidth < 990) {
      this.createCloseButton();
      this.loadEventListeners();
    }
  }

  createCloseButton() {
    const closeSVG = this.drawer
      .querySelector(".icon.icon-close")
      .cloneNode(true);

    this.closeDrawerButton = document.createElement("button");
    this.closeDrawerButton.setAttribute("id", "close-button-drawer");
    this.closeDrawerButton.appendChild(closeSVG);
    this.closeDrawerButton.style.width = "4.4rem";
    this.closeDrawerButton.style.height = "4.4rem";
    this.closeDrawerButton.style.display = "none";
    this.closeDrawerButton.style.justifyContent = "center";
    this.closeDrawerButton.style.alignItems = "center";
    this.closeDrawerButton.style.marginRight = "0px";

    this.closeDrawerButton.querySelector(".icon.icon-close").style.width =
      "2rem";
    this.closeDrawerButton.querySelector(".icon.icon-close").style.height =
      "2rem";
    this.headerIcons.appendChild(this.closeDrawerButton);
  }

  loadEventListeners() {
    this.drawerDetails.addEventListener(
      "toggle",
      this.drawerDetailsToggleEventHandler.bind(this)
    );

    this.closeDrawerButton.addEventListener(
      "click",
      this.closeDrawerButtonEventHandler.bind(this)
    );
  }

  drawerDetailsToggleEventHandler(event) {
    const { newState } = event;
    if (newState === "open") {
      this.summary.style.setProperty("display", "none", "important");
      this.header.style.gridTemplateColumns = "0% 10% 2fr 20%";
      this.closeDrawerButton.style.display = "flex";
      this.heading.style.justifySelf = "start";
    } else {
      this.closeDrawerButton.style.display = "none";
      this.header.style.gridTemplateColumns = "10% 10% 2fr 20%";
      this.summary.style.setProperty("display", "inline-block", "important");
      this.heading.style.justifySelf = "center";
    }
  }

  closeDrawerButtonEventHandler() {
    this.summary.click();
  }
}
let mobileTest = new MobileHeaderLayoutController();
